import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import InnerLayout from "../innerLayout/InnerLayout";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import "./TvGuide.css";
import Select, {  SingleValue } from "react-select";
import { Guid, baseUrl } from "../../../api/baseApi";
import { getBaseChannels } from "../../../api/channelsApi";
import { formatDate, getPastDateByDaysAgo } from "../../../services/dateService";
import { PlayerModel, PlayerTvGuideRow, TvGuideCell, getPlayerTvGuide, getPlayers } from "../../../api/playersApi";
import tvGuidebanner from '../../images/tv-guide.jpg'
import { getToken } from "../../../api/authApi";
import { createPathWithId, Routes } from "../../../constants/routes";


interface TvGuideProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string}

const TvGuide: FunctionComponent<TvGuideProps> = (props : TvGuideProps) => {
    let {history} = props;

    let [isLoading, setIsloading] = useState(false);
    let [channels, setChannels ] = useState<Option<Guid>[]>([]);
    let [selectedChannel, setSelectedChannel] = useState<Guid>('');
    let [selectedStartDate, setSelectedStartDate] = useState<string>(getPastDateByDaysAgo(0));
    let [selectedEndDate, setSelectedEndDate] = useState<string>(getPastDateByDaysAgo(-7));

    let [players, setPlayers ] = useState<PlayerModel[]>([]);
    let [filteredPlayers, setFilteredPlayers ] = useState<Option<Guid>[]>([]);
    let [selectedPlayer, setSelectedPlayer] = useState<Guid>('');

    let [tvGuide, setTvGuide] = useState<PlayerTvGuideRow[]>([]);
    let [downloadUrl, setDownloadUrl] = useState('')

    useEffect(()=>{
        async function fetchData() {
            setIsloading(true);
            await Promise.all([updateChannelsList(),updatePlayersList()])
            setIsloading(false);
        };
        
        fetchData()
    },[])

    useEffect(()=>{
        if(selectedChannel){
            filterPlayersByChannelId(players, selectedChannel)
        } else {
            setSelectedPlayer('')
        }
    },[selectedChannel])

    useEffect(()=>{
        async function fetchData() {
            setIsloading(true);
            await updateTvGuide();
            setIsloading(false);
        };
        
        if(selectedPlayer && selectedStartDate && selectedEndDate){
            fetchData()
        } else {
            setTvGuide([])
        }
    },[selectedPlayer,selectedStartDate,selectedEndDate])

    const updateChannelsList = async () => {
        let result = await getBaseChannels();
        if(result.type === "succes"){
            setChannels(result.data.items.map(it => {return {value: it.id, label: it.name}}));
        }
    }

    const updatePlayersList = async () => {
        const res = await getPlayers();
        setPlayers(res.players)
    }

    const updateTvGuide = async () => {
        let result = await getPlayerTvGuide(selectedPlayer, selectedStartDate, selectedEndDate);
        if(result.type === "succes"){
            setTvGuide(result.data.data.dates)
        }
    }


    const filterPlayersByChannelId = (players: PlayerModel[], channelId: Guid) => {
        const filteredPlayers = players.filter( it => it.channel?.id === channelId)
        setFilteredPlayers(filteredPlayers.map(it => {return {value: it.id, label: it.name}}));
    }

    const onChangeSelectedChannel = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedChannel(value.value);
        } else {
            setSelectedChannel('');
        }
    }

    const onChangeSelectedPlayer = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedPlayer(value.value);
        } else {
            setSelectedPlayer('');
        }
    }

    const onStartDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedStartDate(event.target.value);
    const onEndDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedEndDate(event.target.value); 

    const convertTimeToMinutes = (time:string) => {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return hours * 60 + minutes + seconds / 60;
    };

    const calculateEventTime = (startTime:string, endTime:string, intervalMinutes:number) => {
        const startMinutes = convertTimeToMinutes(startTime);
        const endMinutes = convertTimeToMinutes(endTime);
    
        const startOffset = startMinutes % intervalMinutes;

        const offsetPercentage = (startOffset / intervalMinutes * 100).toFixed(2);
    
        const startInterval = Math.floor(startMinutes / intervalMinutes) + 1;

        const eventDurationPercentage = ((endMinutes - startMinutes) / intervalMinutes * 100).toFixed(2)

        return {
            startInterval,
            offsetPercentage,
            eventDurationPercentage
        };
    }

    const renderTvGuide = (tvGuideRows: PlayerTvGuideRow[]) => {
        return tvGuideRows.map( it => {
            return <div key={`${it.date}-date`} className="tv-guide-program">
                <div className="program-date">{formatDate(it.date)}</div>
                {renderTvGuideCells(it.spans)}
            </div>
        })
    }

    const goToStream = (listId: Guid | null, streamId: Guid | null) => {
        const data = streamId
        if(listId && streamId){
            history.push(createPathWithId(Routes.PriorityList, listId), data)
        }
    }

    const renderTvGuideCells = (cells: TvGuideCell[]) => {
        return cells.map( it => {
            let {startInterval, offsetPercentage, eventDurationPercentage} = calculateEventTime(it.start, it.end, 30)
            return  <div key={it.start+it.end} className="tv-guide-cell" style={{
                            ['--column-start']:`${startInterval + 1}`,
                            ['--left']:`${offsetPercentage}%`,
                            ['--width']:`${eventDurationPercentage}%`,
                        }as React.CSSProperties}>
                        <div className="program-info">
                            <p className="program-title" onClick={() => {goToStream(it.scheduledStreamListId, it.streamId)}}>{it.title}</p>
                            <p className="program-time">{it.start.slice(0, -3)} - {it.end.slice(0, -3)}</p>
                        </div>
                    </div>
        })
    }

    const renderTimeline = (withPseudoLines: boolean = false) => {
        const timelineElements = [];

        if(!withPseudoLines){
            for(let i = 0; i < 24; i++){
                timelineElements.push(
                    <>
                        <div key={`hour-${i}`} className="timeline-slot">{i.toString().padStart(2, '0')}:00</div>
                        <div key={`half-hour-${i}`} className="timeline-slot">{i.toString().padStart(2, '0')}:30</div>
                    </>
                );
            }
    
            return timelineElements;
        } else {
            for(let i = 0; i < 24; i++){
                timelineElements.push(
                    <>
                        <div key={`hourP-${i}`} className="timeline-pseudo-slot"></div>
                        <div key={`half-hourP-${i}`} className="timeline-pseudo-slot"></div>
                    </>
                );
            }
    
            return timelineElements;
        }
    }

    
    return (  
        <InnerLayout 
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="tvGuide">
                <>

                    <div className="timeline-settings mb-30">
                        <div className="tv-guide-banner-block">
                            <img src={tvGuidebanner} alt="" className="tv-guide-banner" />
                        </div>
                        <div className="timeline-settings-elem transformY5">
                            <label>Networks</label>
                            <Select 
                                options={channels}
                                classNamePrefix={`select`}
                                onChange={onChangeSelectedChannel} 
                                isClearable={true}
                            />
                        </div>
                        <div className="timeline-settings-elem transformY5">
                            {selectedChannel && <>
                                <label>Players</label>
                                <Select 
                                    options={filteredPlayers}
                                    classNamePrefix={`select`}
                                    onChange={onChangeSelectedPlayer} 
                                    isClearable={true}
                                />
                            </>}
                        </div>
                        <div className="timeline-settings-elem">
                            <label>Start</label>  
                            <input className="form-control" type="date" onChange={onStartDateChanged} value={selectedStartDate} ></input>
                        </div>
                        <div className="timeline-settings-elem">
                            <label>End</label>  
                            <input className="form-control" type="date" onChange={onEndDateChanged} value={selectedEndDate}></input>
                        </div>
                    </div>

                    { tvGuide.length ? <>
                    <div className="tv-guide-wrapper">
                        <div className="tv-guide-block">
                            <div className="timeline">
                                <div className=""></div>
                                {renderTimeline()}
                            </div>
                            <div className="timeline-pseudo">
                                <div className="timeline-pseudo-slot"></div>
                                {renderTimeline(true)}
                            </div>
                            {renderTvGuide(tvGuide)}
                        </div>
                    </div></> : <p>Please select Network, Player and Dates</p>}

                    <div className="tv-guide-text-block">
                        <p>© Copyright C-Screens 2024 | <a target="_blank" href="https://c-screens.com/">www.c-screens.com</a> | <a href="mailto:prize@c-screens.com">prize@c-screens.com</a> </p>
                        <p>TV Guide Viewing Disclaimer</p>

                        <ol>
                            <li>The TV guide provided is subject to change without prior notice.</li>
                            <li>Adverse weather conditions may have a significant affect on the scheduling and broadcasting of summer sporting events.</li>
                            <li>Changes may occur at the discretion of the landowner and CScreens LTD.</li>
                            <li>We strive to provide accurate and up-to-date information but cannot guarantee the timeliness or accuracy of the content.</li>
                            <li>Users are encouraged to verify scheduling information with the respective TV channels.</li>
                            <li>By using this TV guide, users agree to acknowledge and accept the possibility of changes.</li>
                        </ol>
                    </div>

                    {tvGuide.length ? <div className="d-flex justify-content-end mb-20">
                        <a href={`${baseUrl}pdf/tv-guided-look?playerId=${selectedPlayer}&startTime=${selectedStartDate}&endTime=${selectedEndDate}&token=${getToken()}`} download>Download PDF</a>
                    </div> : <></>}
                    <GlobalSpinner isShow={isLoading} />
                </>
               
        </InnerLayout> );
}

export default withRouter(TvGuide)